import React from 'react';
import PropTypes from 'prop-types';

import MotifCardHeader from '@ey/motif-react-wrapper/CardHeader';
import MotifCardBody from '@ey/motif-react-wrapper/CardBody';
import StyledMotifCard from './StyledMotifCard';

const variants = ['card-border', 'full-width', 'card-no-border'];

const Card = ({children = null, renderHeader = null, variant = variants[0], ...rest}) => {
	const props = {...rest, variant};

	return (
		<StyledMotifCard {...props}>
			{renderHeader && <MotifCardHeader>{renderHeader()}</MotifCardHeader>}
			<MotifCardBody>{children && children}</MotifCardBody>
		</StyledMotifCard>
	);
};

Card.propTypes = {
	renderHeader: PropTypes.func,
	variant: PropTypes.oneOf(variants)
};

export default Card;
